export default __webpack_public_path__ + "static/media/AscendEx-Logo 1.4b01b006.svg";